import apiCall from 'apps/investcore/apiCalls/fund-managers';
import {
  CreatePage,
  DetailPage,
  EditPage,
  ListPage,
} from 'common/ui/admin-CRUD/page';
import { columnsGenerator } from './config';
import ItemDetail from './detail';
import ItemForm from './form';

export const FundManagersListPage = () => (
  <ListPage
    title="All Fund Managers"
    apiCall={apiCall}
    columnsGenerator={columnsGenerator}
    createUrl={`/admin/fund-managers/create`}
  />
);

export const FundManagersDetailPage = () => (
  <DetailPage
    title="Fund Managers"
    apiCall={apiCall}
    listUrl={`/admin/fund-managers`}
    ItemDetail={ItemDetail}
    resourceName="data"
    options={{ editEnabled: true }}
  />
);

export const FundManagersEditPage = () => (
  <EditPage
    title="Fund Managers"
    apiCall={apiCall}
    listUrl={`/admin/fund-managers`}
    ItemForm={ItemForm}
    resourceName="data"
  />
);
export const FundManagersCreatePage = () => (
  <CreatePage
    title="Fund Managers"
    apiCall={apiCall}
    listUrl={`/admin/fund-managers`}
    ItemForm={ItemForm}
    resourceName="data"
  />
);
